import BioLink from './Bio';

export default BioLink;
